import { render, staticRenderFns } from "./navmenu.vue?vue&type=template&id=1ab64970&scoped=true&"
import script from "./navmenu.vue?vue&type=script&lang=js&"
export * from "./navmenu.vue?vue&type=script&lang=js&"
import style0 from "./navmenu.vue?vue&type=style&index=0&id=1ab64970&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab64970",
  null
  
)

export default component.exports